import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getCustomizedReport = payload =>
  call(websocketFetch, 'get_customized_report', payload);
